import { styled } from "styled-components";
import { Constrainer } from "../../internal-components/Layout.js";
import {
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { ExpandableSection } from "../../internal-components/ExpandableSection.js";
import type { BackgroundColor } from "../../types/theme.js";

export interface Section {
  title?: string;
  text?: string;
}

export interface Props {
  sections?: Section[];
  backgroundColor?: BackgroundColor;
}

export const ExpandableContent: React.FC<Props> = ({
  sections = [],
  backgroundColor,
}) => {
  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer $width="small">
          <Sections>
            {sections.map((section, index) => {
              return (
                <ExpandableSection
                  key={index}
                  title={section.title || "Mangler tittel"}
                  text={section.text || ""}
                  backgroundColor={backgroundColor}
                />
              );
            })}
          </Sections>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};

const Sections = styled.div`
  .expandable-section:not(:last-child) {
    margin-bottom: ${(props) => props.theme.spacing.m};
  }
`;
